import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqData } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14">
          <Reveal className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.2em] text-secondary-600">FAQ</span>
            <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于这份时间线
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              第一次来的人最常问的几个问题都收在这里，看完再决定从哪一条开始读。
            </p>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
              {faqData.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                    >
                      <h4 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {faq.q}
                      </h4>
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                        <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}